import type {
  RevokeAccessToCompanyMutation,
  RevokeAccessToCompanyMutationVariables
} from './__generated__/RevokeAccessToCompanyMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  RevokeAccessToCompanyMutation,
  RevokeAccessToCompanyMutationVariables
> = gql`
  mutation RevokeAccessToCompanyMutation($input: RevokeAccessToCompanyInput!) {
    revokeAccessToCompany(input: $input) {
      status
    }
  }
`

export function revokeAccessToCompanyMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      RevokeAccessToCompanyMutation,
      RevokeAccessToCompanyMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
